<!-- Copyright 2023, Common Good Learning Tools LLC -->
<template>
	<k-dialog v-model="dialog_open" max-width="700" persistent scrollable aria-labelledby="satchel-create-account-title" initial-focus-selector="input" @keydown.esc="$emit('dialog_cancel')">
		<k-card>
			<k-card-title style="background-color:#ddd"><b id="satchel-create-account-title">Create New Account</b></k-card-title>
			<k-card-text class="mt-3" style="font-size:16px;line-height:21px;">
				<div>By creating an account and signing in, you will be able to use {{site_config.app_name}}'s commenting features to annotate learning standard frameworks. In addition, administrators will be able to grant you access to view private frameworks.</div>
				<div class="mt-2 pt-2" style="border-top:1px solid #999">Enter your name and email address, then click “CREATE NEW ACCOUNT”. You should then receive an email with a link to activate your new account. Upon clicking the link, you will be automatically signed in to {{site_config.app_name}}, then asked to establish a password.</div>
				<div>
					<div class="d-flex">
						<k-text-field outlined hide-details label="First name" class="mt-4 mr-1" v-model="first_name" placeholder="" data-cy="create_account_fname"></k-text-field>
						<k-text-field outlined hide-details label="Last name" class="mt-4 ml-1" v-model="last_name" placeholder="" data-cy="create_account_lname"></k-text-field>
					</div>
					<div class="d-flex">
						<k-spacer/>
						<div style="flex:0 0 400px"><k-text-field outlined hide-details label="Email" class="mt-4" v-model="email" placeholder="" data-cy="create_account_email"></k-text-field></div>
						<k-spacer/>
					</div>
				</div>
			</k-card-text>
			<k-card-actions class="pa-3" style="background-color:#ddd">
				<k-btn color="secondary" @click="$emit('dialog_cancel')"><k-icon small class="mr-2">fas fa-xmark</k-icon>Cancel</k-btn>
				<k-spacer></k-spacer>
				<k-btn color="primary" @click="create_new_account">Create New Account<k-icon small class="ml-2" data-cy="submit_create_account">fas fa-arrow-right</k-icon></k-btn>
			</k-card-actions>
		</k-card>
	</k-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	props: {
		// req: { type: String, required: true },
		// nreq: { type: String, required: false, default() { return ''} },
	},
	data() { return {
		first_name: '',
		last_name: '',
		email: '',
		dialog_open: true,
	}},
	computed: {
		...mapState(['site_config']),
		...mapGetters([]),
	},
	watch: {
	},
	created() {
	},
	mounted() {
	},
	methods: {
		create_new_account() {
			if (empty(this.first_name)) {
				this.$alert('Please enter your first name.')
				return
			}
			if (empty(this.last_name)) {
				this.$alert('Please enter your last name.')
				return
			}
			if (empty(this.email)) {
				this.$alert('Please enter your email address.')
				return
			}

			let payload = {
				first_name: this.first_name,
				last_name: this.last_name,
				user_email: this.email,
				token_duration: 60,
				token_type: 'create_account'
			}
			U.ajax('send_token_signin_email', payload, result=>{
				U.loading_stop()
				let msg
				if (result.status != 'ok') {
					if (result.status == 'account_previously_created') {
						msg = 'An account for this email already exists! Click on Forgot Password to reset password.'
					} else {
						console.log(sr('Error in token create account ajax call: $1', result.status))
						msg = 'The one-time sign-in link could not be sent.'
						//msg = result.status
					}

				} else {
					msg = `A message has been sent to your email address with a link you can click to verify your ${this.site_config.app_name} account and set your password. If you don’t receive the link within one minute, <b>please check your spam or junk folder</b>, and remember that <b>the link will expire after one hour</b>.`
				}
				this.$alert(msg).then(x=>this.$emit('dialog_cancel'))
			})
		}
	}
}
</script>

<style lang="scss">
</style>
